import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable } from "rxjs";

/**
 * Web service to delete the user.
 */
@Injectable({
  providedIn: "root",
})
export class DeleteUserWS {
  constructor(private handler: BaseHandler) {}
  execute(token: string): Observable<void> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.delete)
      .setAuthorization(new TokenAuthorization(token))
      .setUrl(ApiUrls.DELETE_USER_ENDPOINT())
      .build();
    return this.handler.execute(parameters);
  }
}
